import { render, staticRenderFns } from "./FencingForm.vue?vue&type=template&id=55cdbf38"
import script from "./FencingForm.vue?vue&type=script&lang=ts"
export * from "./FencingForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports